import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import "./style.scss";

import axios from 'util/axios';
import { useDispatch, useSelector } from "react-redux";

import SearchableSelect from "util/component/SearchableSelect";
import AsyncCreatableSelect from "util/component/SearchableSelect/asynccreate";
import AsyncSelectMulti from "util/component/SearchableSelect/asyncMulti";

import { getURLParam, useDidMountEffect } from "util"
import Pagination from 'util/component/Pagination'

import { useNavigate, useLocation } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpWideShort, faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons"

const PAGE_VIEW = 10;

const renderList = (list, clickFn) => {
    const el = list?.result?.map((v, i) => {
        return <tr key={"list" + i} onClick={() => clickFn && clickFn(v)}>
            <td>{v.rownum}</td>
            <td>{v?.projectNm}</td>
            <td>{v?.mbrNo}</td>
            <td>{v?.processCd}</td>
            <td style={{textAlign: "left", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>{v?.description}</td>
            <td className={v?.tempYn === 'Y' ? "temp" : ""}>{v?.revision}</td>
            <td className={v?.readyTempYn === 'Y' ? "temp" : ""}>{v?.readyRevision}</td>
            <td>{v?.userNm}</td>
            <td>{v?.createDt}</td>
        </tr>
    })
    return el;
}

const SheetList = () => {
    const [List, setList] = useState({});
    const [SearchCondition, setSearchCondition] = useState({
        tempYn: "ALL",
        mbrNo: "",
        projectNm: "",
        orderByColumn: "CREATE_DT",
        orderByType: "DESC",
        processCd: "",
        unitCd: "",
        userId: [],
        readyYn : ""
    })
    const [Page, SetPage] = useState(1);

    const dispatch = useDispatch();
    const userSelector = useSelector(store => store.user);

    const stateUrl = useRef(window.location.pathname);
    const navigate = useNavigate();
    const uselocation = useLocation();

    const move = (v) => {
        if (v.userId === userSelector.userId && v.tempYn === "Y") {
            window.location.href = "/mainForm?mid=" + v.sheetCode + "&rev=" + v.revision + "&tempYn=" + v.tempYn;
        } else {
            window.location.href = "/detail?mid=" + v.sheetCode + "&rev=" + v.revision + "&tempYn=" + v.tempYn;
        }
    }

    useEffect(() => {
        const {
            tempYn = "ALL",
            mbrNo = "",
            projectNm = "",
            userId = "",
            orderByColumn = "CREATE_DT",
            orderByType = "DESC",
            processCd = "",
            readyYn = "",
            unitCd = "",
            page = 1
        } = getURLParam()
        setSearchCondition({ tempYn, mbrNo, projectNm, orderByColumn, orderByType, unitCd: decodeURI(unitCd), processCd,readyYn, userId: userId ? decodeURIComponent(userId).split(",") : [] })
        SetPage(page);
    }, [uselocation])

    useDidMountEffect(() => {
        getList();
    }, [SearchCondition])

    const setConditions = useCallback((val, opt, ordby) => {
        let obj = getURLParam();
        if (!!ordby) {
            obj[val.name] = val.value;
            obj[opt.name] = opt.value;
        } else {
            if (!!val && !!val?.value) {
                if (opt.name === "tempYn" || opt.name === "processCd" || opt.name === "readyYn") {
                    obj[opt.name] = val?.value;
                } else if (opt.name === "userId") {
                    obj[opt.name] = val?.map(e => e.value).join(",");
                } else if (opt.name === "unitCd") {
                    obj[opt.name] = val?.value + "|BIO|" + encodeURI(val?.label);
                } else {
                    obj[opt.name] = val?.label;
                }
            } else if (val?.length > 0) {
                if (opt.name === "userId") {
                    obj[opt.name] = val?.map(e => e.value).join(",");
                } else {
                    delete obj[opt.name];
                }
            } else {
                delete obj[opt.name];
            }
        }
        delete obj['page'];
        const searchParams = new URLSearchParams(obj);
        navigate(`${stateUrl.current}?${searchParams.toString()}`)
    }, [uselocation]);


    const movePage = useCallback((i) => {
        let obj = getURLParam();
        obj['page'] = i;
        const searchParams = new URLSearchParams(obj);
        navigate(`${stateUrl.current}?${searchParams.toString()}`)
    }, [Page, SearchCondition])

    const getList = useCallback(async () => {
        dispatch({ type: "LOADING_ON" })
        try {
            const { tempYn, mbrNo, projectNm, orderByColumn, orderByType, userId, processCd, readyYn, unitCd } = SearchCondition;
            let condition = { orderByColumn, orderByType };
            if (!!tempYn && tempYn !== "ALL") condition.tempYn = tempYn;
            if (!!mbrNo) condition = { ...condition, mbrNo };
            if (!!projectNm) condition = { ...condition, projectNm };
            if (!!processCd) condition = { ...condition, processCd };
            if (!!readyYn) condition = { ...condition, readyYn };
            if (!!unitCd) condition = { ...condition, unitCd: unitCd.split("|BIO|")[0] };
            if (userId.length > 0) condition = { ...condition, userId: "'" + userId.join("','") + "'" };

            const response = await axios.post(process.env.REACT_APP_API + "/pcsList/retrievePcsCombineList",
                { curPage: Page, boardView: PAGE_VIEW, ...condition })
                .then(Response => Response.data.data)

            setList(response);
        } catch (e) {
            console.error(e)
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    }, [Page, SearchCondition])

    const changeOrderby = (e) => {
        const dtype = e.target.dataset.type;
        let ord;
        if (dtype === SearchCondition.orderByColumn) {
            ord = SearchCondition.orderByType === "DESC" ? "ASC" : "DESC";
        } else {
            ord = "DESC";
        }
        const val = { name: "orderByColumn", value: dtype };
        const opt = { name: "orderByType", value: ord }
        setConditions(val, opt, true);
    }

    const render = useMemo(() => renderList(List, move), [List])
    return (
        <div className="bpl-container">
            <section className="sheetlist">
                <div className="top">
                    <h3 className="list_name">MBR Sheet List</h3>
                </div>
                <div className="middle">
                    <div className="search-box">
                        <div className="search-item">
                            <p>TEMP:</p>
                            <div>
                                <SearchableSelect
                                    border={"ON"}
                                    search={false}
                                    arrow
                                    placeholder=""
                                    onChange={setConditions}
                                    name="tempYn"
                                    value={SearchCondition.tempYn}
                                    options={[
                                        {label: "ALL", value: "ALL"},
                                        {label: "TEMP ONLY", value: "Y"},
                                        {label: "LIVE ONLY", value: "N"}
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="search-item">
                            <p>Project:</p>
                            <div>
                                <AsyncCreatableSelect
                                    api="/api/pcsList/retrievePcsListCondition"
                                    body={{column: "PROJECT_NM"}}
                                    arrow
                                    value={SearchCondition.projectNm}
                                    border
                                    onChange={setConditions}
                                    name="projectNm"
                                />
                            </div>
                        </div>
                        <div className="search-item">
                            <p>MBR No:</p>
                            <div>
                                <AsyncCreatableSelect
                                    api="/api/pcsList/retrievePcsListCondition"
                                    body={{column: "MBR_NO"}}
                                    arrow
                                    border
                                    value={SearchCondition?.mbrNo}
                                    onChange={setConditions}
                                    name="mbrNo"
                                />

                            </div>
                        </div>
                        <div className="search-item">
                            <p>Process:</p>
                            <div>
                                <SearchableSelect
                                    border={"ON"}
                                    search={false}
                                    arrow
                                    placeholder=""
                                    onChange={setConditions}
                                    name="processCd"
                                    value={SearchCondition.processCd}
                                    options={[
                                        {label: "　", value: ""},
                                        {label: "USP", value: "USP"},
                                        {label: "DSP", value: "DSP"}
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="search-item">
                            <p>Ready:</p>
                            <div>
                                <SearchableSelect
                                    border={"ON"}
                                    search={false}
                                    arrow
                                    placeholder=""
                                    onChange={setConditions}
                                    name="readyYn"
                                    value={SearchCondition.readyYn}
                                    options={[
                                        {label: "　", value: ""},
                                        {label: "Y", value: "Y"},
                                        {label: "N", value: "N"}
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="search-item">
                            <p>Owner:</p>
                            <div style={{width: "300px"}}>
                                <AsyncSelectMulti
                                    api="/api/user/retrieveUserListForSearch"
                                    arrow
                                    value={SearchCondition.userId}
                                    onChange={setConditions}
                                    name="userId"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom">
                    <table>
                        <colgroup>
                            <col width="100px"></col>
                            <col></col>
                            <col></col>
                            <col></col>
                            <col></col>
                            <col width="10%"></col>
                            <col width="8%"></col>
                            <col></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>No</th>
                            <th>Project</th>
                            <th style={{cursor: "pointer"}} onClick={changeOrderby} data-type="MBR_NO">
                                MBR No.
                                {
                                    SearchCondition.orderByColumn === "MBR_NO" && <>&nbsp;
                                        {(SearchCondition.orderByType !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} />
                                                : <FontAwesomeIcon icon={faArrowDownWideShort} />)}
                                        </>
                                    }
                                </th>
                                <th>Process</th>
                                <th>Description</th>
                                <th>Revision</th>
                                <th>Ready Revision</th>
                                <th>Owner</th>
                                <th style={{ cursor: "pointer" }} onClick={changeOrderby} data-type="CREATE_DT">
                                    Created Date
                                    {
                                        SearchCondition.orderByColumn === "CREATE_DT" && <>&nbsp;
                                            {(SearchCondition.orderByType !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} />
                                                : <FontAwesomeIcon icon={faArrowDownWideShort} />)}
                                        </>
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {render}
                        </tbody>
                    </table>

                    <div className="bottom">
                        {(userSelector.isWriter && userSelector.isAdmin) && <div className="new_btn">
                            <a href="/mainForm">
                                Create New Templete
                            </a>
                        </div>}
                        {List.boardPager && <Pagination data={List.boardPager} onClick={movePage} style={{ marginTop: "5px", float: "right", marginRight: "15px" }} />}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default SheetList;